import { useMutation, useQuery } from '@apollo/client';
import {
    GET_COMPETITORS,
    CREATE_COMPETITOR,
} from '../../apollo/queries/competitor';
import { CompetitorFilterInput } from '../../codegen/graphql';

export function useGetCompetitors(
    filter: CompetitorFilterInput & { advertisingZoneId?: string },
    options?: Parameters<typeof useQuery>[1],
) {
    const safeFilter = filter ?? {};

    const hasValidFilter =
        safeFilter.advertisingZoneId || safeFilter.storeId || safeFilter.name;

    return useQuery(GET_COMPETITORS, {
        variables: { competitorFilterInput: safeFilter },
        skip: !hasValidFilter,
        ...options,
    });
}

export function useCreateCompetitor() {
    return useMutation(CREATE_COMPETITOR);
}
